import { AppErrorResponse } from '../services/axios';

export interface ToastLike {
  error: (message: string) => void;
}

export const handleAppError = (
  toast: ToastLike | null | undefined,
  error: AppErrorResponse | undefined,
  fallbackMessage: string
): void => {
  if (!toast) {
    return;
  }
  if (error?.details?.length) {
    error.details.forEach((detail) => {
      const message =
        (detail as { translatedMessage?: string }).translatedMessage ||
        fallbackMessage;
      toast.error(message);
    });
    return;
  }
  toast.error(fallbackMessage);
};
